export const getExternalPath = (path: string) => {
  return `${window.location.origin}/${path}`;
};
